export const formatIban = (value: string) => {
    return (value)
        ? value.replace(/[^\da-zA-Z]/g, '').replace(/(.{4})/g, '$1 ').trim().toUpperCase()
        : '';
};

export const currency = (value: number | string, symbol = '€') => {
    return (value >= 0) ? parseFloat(value as string).toFixed(2) + ' ' + symbol : '';
};